import {optionalMaterialInput} from "#material/nodes/base/connection/validation/parameters"
import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {ExchangeNodeName} from "#material/exchange/node-name"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {vec3} from "#material/types/vector"
import {color} from "@cm/graph-v3"
import {z} from "zod/v4-mini"
import {materialClosureOutput} from "#material/nodes/base/material/validation/io"

export interface BsdfTranslucentSockets extends MaterialNodeSockets {
    inputs: {
        color: "color" // found in inputs: color; found in settings: color; inferred from data: float3
        normal: "normal" // found in inputs: normal; found in settings: vector; inferred from data: float3
    }
    settings: {
        color: "color" // found in inputs: -; found in settings: color; inferred from data: float3
        normal: "normal" // found in inputs: -; found in settings: vector; inferred from data: float3
    }
    outputs: {
        bsdf: "closure"
    }
}

export const bsdfTranslucentDefinition = {
    exchangeFormat: {
        nodeName: ExchangeNodeName.ShaderNodeBsdfTranslucent,
    },
    nodeClass: "BsdfTranslucent",
    ui: {
        label: "Translucent BSDF",
        color: "#2d8a5d",
        items: [
            {name: "bsdf", valueType: "closure", label: "BSDF", output: true},
            {name: "color", valueType: "color", label: "Color", input: true, setting: true, defaultValue: {r: 0.8, g: 0.8, b: 0.8}},
            {name: "normal", valueType: "normal", label: "Normal", input: true, setting: false, defaultValue: {x: 0, y: 0, z: 0}},
        ],
        support: {
            cycles: true,
            three: true,
        },
    },
    validation: {
        returns: z.strictObject({bsdf: materialClosureOutput}),
        parameters: z.strictObject({
            inputs: z.strictObject({color: optionalMaterialInput, normal: optionalMaterialInput}),
            settings: z.strictObject({
                color: z.optional(color),
                normal: z.optional(vec3),
            }),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<BsdfTranslucentSockets>
